import React from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import ShimmerPlaceholder, { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';

const PledgedMFShimmer = () => {
    const ShimmerPlaceholderWithGradient = createShimmerPlaceholder(LinearGradient);
  return (
    <View style={{ padding: 16 }}>
      {/* List items shimmer - 4 rows */}
      {[...Array(5)].map((_, index) => (
        <View key={index} style={{ marginBottom: 32 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <ShimmerPlaceholderWithGradient 
              shimmerStyle={{ width: '65%', height: 20, borderRadius: 4 }}
              visible={false}
              shimmerColors={['#ebebeb', '#ddd', '#ebebeb']}
              duration={1500}
            />
            <ShimmerPlaceholderWithGradient 
              shimmerStyle={{ width: 80, height: 20, borderRadius: 4 }}
              visible={false}
              shimmerColors={['#ebebeb', '#ddd', '#ebebeb']}
              duration={1500}
            />
          </View>
          <ShimmerPlaceholderWithGradient
            shimmerStyle={{ width: '50%', height: 16, borderRadius: 4, marginTop: 12 }}
            visible={false}
            shimmerColors={['#ebebeb', '#ddd', '#ebebeb']}
            duration={2000}
          />
        </View>
      ))}
    </View>
  );
};

export default PledgedMFShimmer;
